import { useSelector } from 'react-redux';

import { Environment } from 'dashboard/models/environment';
import { RootState } from 'dashboard/redux/store';

/**
 * @name `useCurrentEnvironmentStatus`
 *
 * A hook that returns the current environment's status.
 *
 */
export default () => {
  const currentEnvironment = useSelector<RootState, Environment>(
    (state) => state.currentEnvironment.currentEnvironment,
  );
  return currentEnvironment?.attributes?.status;
};
